export * from "@vaadin/tooltip/vaadin-tooltip.js";
export * from './generated/Tooltip.js';
